import { useState } from "react";
// import Slider from "react-slick";
import "./LeftImages.css";
// import ImageInnerZoom from "./ImageInnerZoom";

// import Swiper core and required modules
import { Navigation, Thumbs, FreeMode, Zoom } from "swiper";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";

// Import Swiper styles
import "swiper/swiper-bundle.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "swiper/modules/zoom/zoom.min.css";

function LeftImages({ images }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <div>
      <section id="left-image">
        <div className="collection-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-1 col-sm-2 col-xs-12 p-0">
                <div className="row">
                  <div className="col-12 p-0">
                    <Swiper
                      centeredSlides={true}
                      centeredSlidesBounds={true}
                      watchOverflow={true}
                      onSwiper={setThumbsSwiper}
                      slidesPerView={images?.length < 4 ? images?.length : 4}
                      loop={false}
                      // spaceBetween={5}
                      freeMode={true}
                      watchSlidesProgress={true}
                      modules={[FreeMode, Navigation, Thumbs]}
                      direction={"vertical"}
                      className="mySwiper left-vertical-swiper"
                    >
                      {images?.map((image, index) => (
                        <SwiperSlide key={index}>
                          <div>
                            <img
                              src={image.src}
                              alt=""
                              className="img-fluid nav-img"
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              </div>
              <div className="col-lg-11 col-sm-10 col-xs-12">
                <Swiper
                  watchOverflow={true}
                  // watchSlidesVisibility={true}
                  watchSlidesProgress={true}
                  preventInteractionOnTransition={true}
                  spaceBetween={10}
                  centeredSlides={true}
                  pagination={false}
                  thumbs={{ swiper: thumbsSwiper }}
                  navigation={false}
                  // loop={true}
                  zoom={true}
                  modules={[FreeMode, Navigation, Thumbs, Zoom]}
                  effect="fade"
                  fadeEffect={{ crossFade: true }}
                  className="mySwiper"
                >
                  {images.map((image, index) => {                    
                    return (
                      <SwiperSlide key={"mySwiper-2" + index}>                      
                        <div className="swiper-zoom-container">
                          <img src={image.src} alt="" />
                        </div>
                      </SwiperSlide>
                    );                    
                  })}                    
                </Swiper>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LeftImages;
